import React from 'react';
import { useSearchParams } from 'react-router-dom';
import DevFormConfirmation from 'app/dev/DevFormConfirmation';
import { Box, Stack } from '@mui/material';
import DevAppBuilderFormComponents from 'app/dev/DevAppBuilderFormComponents';
import DevToastExample from './DevToastExample';
import DevKnowledgeGraph from './DevKnowledgeGraph';
import RouteLink from 'components/common/route-link/RouteLink';

const ComponentMap = new Map<string, React.ComponentType>([
    ['form_confirmation', DevFormConfirmation],
    ['app_builder_form_components', DevAppBuilderFormComponents],
    ['toast_example', DevToastExample],
    ['knowledge_graph', DevKnowledgeGraph],
]);

export default function DevComponent() {
    const [searchParams] = useSearchParams();
    const componentName = searchParams.get('c') ?? '';

    let content: React.ReactNode = (
        <Stack>
            <Box>Components:</Box>
            <Box>
                <ul>
                    <li>
                        <RouteLink to="/dev/component?c=form_confirmation">Form Confirmation</RouteLink>
                    </li>
                    <li>
                        <RouteLink to="/dev/component?c=app_builder_form_components">
                            AppBuilderFormComponents Example
                        </RouteLink>
                    </li>
                    <li>
                        <RouteLink to="/dev/component?c=toast_example">Toast Example</RouteLink>
                    </li>
                    <li>
                        <RouteLink to="/dev/component?c=knowledge_graph">Knowledge Graph</RouteLink>
                    </li>
                </ul>
            </Box>
        </Stack>
    );

    if (ComponentMap.has(componentName)) {
        const Component = ComponentMap.get(componentName)!;
        content = <Component />;
    }

    return (
        <Stack
            className={
                'default-components form-components-indent scroll-content-container scroll-content-container--form'
            }
            sx={{
                overflow: 'auto',
                flexGrow: 1,
                width: '100%',
                pt: 4,
                pb: 3,
                px: (theme) => theme.size.pxValue(theme.size.containerIndentX),
            }}
        >
            {content}
        </Stack>
    );
}
